import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { combineLatest, Observable, timer, map, take } from 'rxjs';

import { hasOrderData, OrderPartStatus, OrderState, orderState } from '@fcom/common-booking';
import { AppState } from '@fcom/core';

import { ManageBookingService } from '../../../services';
import { StateActions } from '../../../store';
import { getStage } from '../../../store/selectors';
import { MmbStage } from '../../../enums';

@Injectable()
export class ViewGuard implements CanActivate {
  private DELAY_ON_UPDATE_INTERRUPTED = 10000;

  constructor(
    private store$: Store<AppState>,
    private router: Router,
    private manageBookingService: ManageBookingService
  ) {}

  canActivate(): Observable<boolean> {
    return combineLatest([
      this.store$.pipe(hasOrderData()),
      this.store$.pipe(getStage()),
      this.store$.pipe(orderState()),
    ]).pipe(
      take(1),
      map(([hasOrderData, stage, orderState]: [boolean, MmbStage, OrderState]) => {
        if (hasOrderData) {
          const updateInterrupted =
            !this.router.navigated &&
            Object.values(orderState?.isUpdating || []).some((value) => value === OrderPartStatus.UPDATING);
          if (updateInterrupted && orderState?.PNR) {
            timer(this.DELAY_ON_UPDATE_INTERRUPTED)
              .pipe(take(1))
              // eslint-disable-next-line rxjs-x/no-subscribe-in-pipe
              .subscribe(() => {
                this.manageBookingService.getOrderWithIdAndHash(
                  orderState.orderData.id,
                  orderState.orderData.hash,
                  false
                );
              });
          }

          if (stage !== MmbStage.VIEW) {
            this.store$.dispatch(StateActions.setStage({ stage: MmbStage.VIEW }));
          }
          return true;
        }

        this.store$.dispatch(StateActions.setStage({ stage: MmbStage.LOGIN }));
        return false;
      })
    );
  }
}
